/**
 * Rounds and locale-formats the average score inside the Judge.me review widget
 * so it matches the ratings rendered elsewhere in the theme (one decimal, and a
 * comma separator on locales that use one).
 *
 * The widget renders asynchronously and re-renders on sort, filter and paging,
 * so a MutationObserver scoped to the widget root keeps the value corrected.
 * Callbacks only set a flag; the single query runs once per frame.
 */
(() => {
  const root = document.getElementById('judgeme_product_reviews');
  if (!root) return;

  const SELECTOR = '.jdgm-rev-widg__summary-average';
  const locale = document.documentElement.lang || undefined;
  let scheduled = 0;

  const format = (el) => {
    const value = parseFloat(el.textContent.trim().replace(',', '.'));
    if (!Number.isFinite(value)) return;

    const formatted = value.toLocaleString(locale, {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    });

    if (el.textContent !== formatted) el.textContent = formatted;
  };

  const run = () => {
    scheduled = 0;
    const el = root.querySelector(SELECTOR);
    if (el) format(el);
  };

  const schedule = () => {
    if (!scheduled) scheduled = requestAnimationFrame(run);
  };

  run();
  new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
})();
